import "./MessageBubble.scss"
import {useEffect, useState } from "react";
import { IChatOption, IChatResponse, RoleType } from "../../../../shared/models/chat_models"
import { exportChatQueryAsCSV, exportChatQueryAsJSON } from "../../chat-utils";
import {
  Table, TableBody, TableCell, TableHead, TableRow, TablePagination
} from '@mui/material';

interface IMessageBubbleProps {
    message: string | IChatResponse,
    sender: RoleType,
    chatOptions: Array<IChatOption>
}

const MessageBubble = (props: IMessageBubbleProps) => {
    const [debug, setDebug] = useState(false)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    useEffect(() => {
        props.chatOptions.forEach((x) => {
            if(x.name.toLowerCase() === "debug")
                setDebug(x.checked)
        })
    }, [props.chatOptions])

    const handleChangePage = (newPage: number) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleChangeRowsPerPage = (rows: string) => {
        setRowsPerPage(parseInt(rows, 10));
        setPage(0); // Reset to first page
    };

    return (
        <>
        {props.sender === 'user' && typeof(props.message) === 'string' &&
            <span className={props.sender + "-message"}>
                {props.message}
            </span>
        }
        {props.sender === 'system' && typeof(props.message) === 'string' &&
            <span className={props.sender + "-message my-3"}>
                {props.message}
            </span>

        }
        {props.sender === 'assistant' && typeof(props.message) !== 'string' &&
            <div className={props.sender + "-message"}>
                <span>
                    {props.message.data.length === 0 ?
                        <>No results found, either no data exists matching your query or your query needs to be reworded</>
                    :
                        <>
                            Your query returned {props.message.data.length} results:
                        </>
                    }
                </span>
                {debug && 
                    <div className="mt-3">
                        Query Used:
                        <span className="debug-message">
                            <pre>{JSON.stringify(props.message.query, null, 2)}</pre>
                        </span>
                    </div>
                }
                <div className="assistant-table-wrapper hide-scrollbar">
                    <Table className="assistant-table" size="small" stickyHeader>
                        <TableHead>
                            <TableRow>
                                {props.message.keys.map((key, index) => 
                                    <TableCell 
                                        key={index}
                                        style={{textTransform: 'capitalize'}}
                                        padding="none"
                                        sx={{ backgroundColor: '#262626', padding: '10px' }}
                                    >{key.replace("_", " ")}
                                    </TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.message.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((tableData, index) =>
                                <TableRow
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    key={index}
                                >
                                    {tableData.map((data: any, index: number) => {
                                        delete data.spacecow_tags
                                        return (
                                            <TableCell 
                                                key={index}
                                                padding="none"
                                                sx={{ backgroundColor: '#383838', padding: '10px'}}
                                            >
                                            {JSON.stringify(data)}
                                            </TableCell >
                                        )
                                    }
                                    )}
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    {props.message.data.length > 0 &&
                        <div style={{width: '100%'}}>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={props.message.data.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={(e) => e?.pageX && handleChangePage(e?.pageX)}
                                onRowsPerPageChange={(e) => handleChangeRowsPerPage(e.target.value)}
                                sx={{ backgroundColor: '#262626', width: "100%", padding: '10px' }}
                            />
                        </div>
                    }
                </div>
                {props.message.data.length > 0 &&
                    <div className="export-button-wrapper">
                        <button 
                            onClick={() => 
                                typeof(props.message) !== 'string' ? // Dumb typescript check
                                    exportChatQueryAsCSV(props.message.keys, props.message.data) 
                                : 
                                    null
                            } 
                            // variant="outline-success"
                        >Export CSV</button>
                        <button 
                            className="json-export"
                            onClick={() => 
                                typeof(props.message) !== 'string' ?
                                    exportChatQueryAsJSON(props.message.keys, props.message.data) 
                                : 
                                    null
                            } 
                            // variant="outline-warning"
                        >Export JSON</button>
                    </div>
                }
            </div>
        }
        </>
    )
}

export default MessageBubble